// // import { Link } from "@tanstack/react-router";
// // import { buttonVariants } from "@workspace/web-ui/components/button";
// // import { cn } from "@workspace/web-ui/lib/utils";

// import { getRouteApi } from "@tanstack/react-router";
// import { FormattedEncounter } from "../types";
// import { RecommendedTask } from "./recommended-task";
// // import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs";
// // import { QUESTION_LABELS } from "../../quick-actions/components/drawers/consultation-modal";
// import { PatientDetailsConditional } from "~/features/dashboard/components/patient/patient-details-conditional";
// // import { UrgentCareTaskButtons } from "~/features/dashboard/components/tasks/urgent-care-task";
// // import { buttonVariants } from "@workspace/web-ui/components/button";
// // import { cn } from "@workspace/web-ui/lib/utils";


// const COLORS = {
//     TEXT_PRIMARY: '#2D2F35',
//     TEXT_SECONDARY: '#667085',
// } as const;

// // Skeleton loader for consultation details
// export function ConsultationDetailsSkeleton() {
//     return (
//         <div className="flex flex-col w-full h-full bg-white rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px] animate-pulse gap-4">
//             <div className="h-8 w-2/3 bg-gray-200 rounded mb-2" />
//             <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between mb-1 w-full">
//                 <div className="flex flex-col gap-2 w-full sm:w-auto">
//                     <div className="h-8 w-1/2 bg-gray-200 rounded mb-1" />
//                     <div className="flex gap-2">
//                         <div className="h-4 w-20 bg-gray-200 rounded" />
//                         <div className="h-4 w-12 bg-gray-200 rounded" />
//                         <div className="h-4 w-10 bg-gray-200 rounded" />
//                     </div>
//                 </div>
//             </div>
//             <div className="flex gap-2 mb-4">
//                 <div className="h-6 w-24 bg-gray-200 rounded" />
//                 <div className="h-6 w-16 bg-gray-200 rounded" />
//             </div>
//             <div className="flex flex-col w-full text-left pb-3 mb-6 gap-2">
//                 <div className="h-5 w-1/3 bg-gray-200 rounded mb-2" />
//                 <div className="grid grid-cols-[150px_1fr] gap-8">
//                     <div className="flex flex-col gap-2">
//                         <div className="h-4 w-16 bg-gray-200 rounded" />
//                         <div className="h-4 w-20 bg-gray-200 rounded" />
//                     </div>
//                     <div className="flex flex-col gap-2">
//                         <div className="h-4 w-20 bg-gray-200 rounded" />
//                         <div className="h-4 w-24 bg-gray-200 rounded" />
//                     </div>
//                 </div>
//             </div>
//             <div className="flex flex-col gap-3 w-full p-4 text-left rounded-[16px] border border-[#0404041A] pb-3 mb-6">
//                 <div className="h-6 w-1/3 bg-gray-200 rounded mb-2" />
//                 <div className="grid grid-cols-[min-content_1fr] text-sm gap-8">
//                     <div className="flex flex-col gap-2">
//                         {[...Array(5)].map((_, i) => <div key={i} className="h-4 w-10 bg-gray-200 rounded" />)}
//                     </div>
//                     <div className="flex flex-col gap-2 font-medium">
//                         {[...Array(5)].map((_, i) => <div key={i} className="h-4 w-16 bg-gray-200 rounded" />)}
//                     </div>
//                 </div>
//             </div>
//             <div className="w-full flex gap-4 bg-[#EBF0FB] p-4 rounded-[8px]">
//                 <div className="h-10 w-1/2 bg-gray-200 rounded" />
//             </div>
//             <div className="flex flex-col sm:flex-row justify-between items-center w-full p-3 mt-4 gap-2">
//                 <div className="h-6 w-1/3 bg-gray-200 rounded" />
//                 <div className="h-10 w-24 bg-gray-200 rounded" />
//             </div>
//             <div className="mb-5 w-full flex flex-col gap-2">
//                 <div className="h-8 w-full bg-gray-200 rounded" />
//                 <div className="h-8 w-2/3 bg-gray-200 rounded" />
//             </div>
//         </div>
//     );
// }

// // This component contains the actual consultation details content
// export const ConsultationDetailsContent = ({ encounter }: { encounter: FormattedEncounter }) => {
//     const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
//     const { program } = routeApi.useParams();

//     // const handleAssignMedication = () => {
//     //     console.log("Assign medication for encounter:");
//     //     // Add your medication assignment logic here
//     // };

//     // const handleAssignAppointment = () => {
//     //     console.log("Assign appointment for encounter:");
//     //     // Add your appointment assignment logic here
//     // };

//     return (
//         <>
//             {program === "weight-loss" && (
//                 <div className="flex flex-col w-full h-full bg-[#FFFFFF] rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px]">
//                     {/* Patient info section */}
//                     <div className="flex items-center gap-2 mb-4">
//                         {/* <span className="bg-[#4272DD1A] text-[#4272DD] text-xs font-medium py-[2px] px-[6px] rounded-[888px]  flex items-center gap-2 w-fit">
//                     <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <g clip-path="url(#clip0_7677_5977)">
//                             <path d="M6.99935 13.3332C10.221 13.3332 12.8327 10.7215 12.8327 7.49984C12.8327 4.27818 10.221 1.6665 6.99935 1.6665C3.77769 1.6665 1.16602 4.27818 1.16602 7.49984C1.16602 10.7215 3.77769 13.3332 6.99935 13.3332Z" stroke="#4272DD" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
//                         </g>
//                         <defs>
//                             <clipPath id="clip0_7677_5977">
//                                 <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
//                             </clipPath>
//                         </defs>
//                     </svg>
//                     Action needed
//                 </span> */}
//                         <span className="bg-white text-[#B01F80] text-xs font-medium py-[2px] px-[6px] rounded-[888px] border border-[#B01F80] w-fit">
//                             Urgent
//                         </span>
//                     </div>
//                     <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between mb-1 w-full">

//                         <div className="flex flex-col gap-2 w-full sm:w-auto">
//                             <h2 className="text-2xl sm:text-[32px] text-[#2D2F35] mb-1 font-medium truncate max-w-full">{encounter?.title}</h2>

//                             <div className="flex flex-wrap items-center gap-y-1 gap-x-2">
//                                 <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
//                                     Weight Loss Program
//                                 </span>
//                                 {/* <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
//                                     Urgent Care Program
//                                 </span> */}
//                                 {encounter.patient.age && (<>
//                                     <span className="hidden sm:inline mx-1" style={{ color: COLORS.TEXT_SECONDARY }}>•</span>
//                                     <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
//                                         {encounter?.patient.age} years
//                                     </span>
//                                 </>)}
//                                 {encounter?.patient.gender && (<><span className="hidden sm:inline mx-1" style={{ color: COLORS.TEXT_SECONDARY }}>•</span>
//                                     <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
//                                         {encounter?.patient.gender}
//                                     </span></>)}
//                             </div>
//                         </div>
//                     </div>



//                     <div className="flex flex-col w-full text-left pb-3 mb-6">
//                         <h2 className="text-[#2D2F35] font-medium text-base mb-4">Request Information</h2>
//                         <div className="grid grid-cols-[150px_1fr] gap-8">
//                             <div className="flex flex-col gap-2">
//                                 <p className="text-[#464B55] text-sm">Program:</p>
//                                 <p className="text-[#464B55] text-sm">Request Date:</p>
//                                 <p className="text-[#1A202C] text-sm">Consultation:</p>
//                             </div>
//                             <div className="flex flex-col gap-2">
//                                 <p className="text-[#1A202C] text-sm">Weight Loss</p>
//                                 {/* <p className="text-[#1A202C] text-sm">Urgent Care</p> */}
//                                 <p className="text-[#1A202C] text-sm">{encounter?.createdAt}</p>
//                                 <p className="text-[#1A202C] text-sm">Express consultation</p>
//                             </div>
//                         </div>
//                     </div>


//                     <PatientDetailsConditional encounter={encounter} program={program} />
//                     {/* 
//             <div className="w-full flex gap-4 bg-[#EBF0FB] p-4 rounded-[8px]">
//                 <Link
//                     className={cn(buttonVariants({ variant: "outline" }), "bg-transparent w-full text-[#4272DD] rounded-[8px] border-[#4272DD] border-2 py-3 px-4 hover:bg-[#4272DD] hover:text-white")}
//                     to="/dashboard/patients/patient/$id"
//                     params={{
//                         id: encounter?.patient.id || ""
//                     }}
//                     search={{
//                         name: encounter?.patient.name.replace(/\s+/g, "") || ""
//                     }}
//                 >
//                     View Patient Log
//                 </Link>
//             </div> */}

//                     {/* Recommended Tasks */}
//                     <RecommendedTask encounterId={encounter.encounterId} className="" />
//                 </div>
//             )}
//             {program === "urgent-care" && (
//                 <div className="flex flex-col w-full h-full bg-[#FFFFFF] rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px]">
//                     <div className="flex items-center gap-2 mb-4">
//                         <span className="bg-white text-[#B01F80] text-xs font-medium py-[2px] px-[6px] rounded-[888px] border border-[#B01F80] w-fit">
//                             Consultation
//                         </span>
//                     </div>
//                     <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between mb-1 w-full">

//                         <div className="flex flex-col gap-2 w-full sm:w-auto">
//                             <h2 className="text-2xl sm:text-[32px] text-[#2D2F35] mb-1 font-medium truncate max-w-full">{encounter?.title}</h2>

//                             {/* <div className="flex flex-wrap items-center gap-y-1 gap-x-2 mb-1">
//                                 <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
//                                     {encounter.patient.email}
//                                 </span>
//                                 {encounter?.patient.gender && (<><span className="hidden sm:inline mx-1" style={{ color: COLORS.TEXT_SECONDARY }}>•</span>
//                                     <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
//                                         {encounter?.patient.gender}
//                                     </span></>)}
//                             </div> */}
//                         </div>
//                     </div>

//                     <div className="flex flex-col w-full text-left pb-3 mb-4 mt-4">

//                         <div className="flex justify-between w-[80%]">
//                             <div className="text-[#464B55] text-sm">
//                                 Submitted:
//                                 <p className="text-[#1A202C] text-sm">{encounter?.createdAt}</p>
//                             </div>
//                             <div className="text-[#464B55] text-sm">
//                                 Program:
//                                 <p className="text-[#1A202C] text-sm">Urgent Care</p>
//                             </div>
//                         </div>
//                     </div>


//                     <PatientDetailsConditional encounter={encounter} program={program} />

//                     {/* <div className="mt-3">
//                         <UrgentCareTaskButtons
//                             onAssignMedication={handleAssignMedication}
//                             onAssignAppointment={handleAssignAppointment}
//                         // selectedSession={selectedSession}
//                         />
//                     </div> */}

//                     {/* Recommended Tasks */}


//                 </div>
//             )}
//         </>
//     );
// };




// import { Link } from "@tanstack/react-router";
// import { buttonVariants } from "@workspace/web-ui/components/button";
// import { cn } from "@workspace/web-ui/lib/utils";

import { getRouteApi } from "@tanstack/react-router"
import type { FormattedEncounter } from "../types"
import { RecommendedTask } from "./recommended-task"
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs";
// import { QUESTION_LABELS } from "../../quick-actions/components/drawers/consultation-modal";
import { PatientDetailsConditional } from "~/features/dashboard/components/patient/patient-details-conditional"
// import { UrgentCareTaskButtons } from "~/features/dashboard/components/tasks/urgent-care-task";
// import { buttonVariants } from "@workspace/web-ui/components/button";
// import { cn } from "@workspace/web-ui/lib/utils";
import { Info, CircleCheck, Clock } from "lucide-react"
import { Button } from "@workspace/web-ui/components/button"
import { Image } from "@workspace/web-ui/components/image";
import { useSendActionNeededMutation } from "../../patient-logs/api/mutations"
import { toast } from "sonner"
import { ConsultationStatus } from "../../quick-actions/components/consultation-status"
import { NotesContainer } from "~/features/dashboard/components/notes"
import { ResolveToggle } from "~/features/dashboard/components/resolve-toggle"

const COLORS = {
    TEXT_PRIMARY: "#2D2F35",
    TEXT_SECONDARY: "#667085",
} as const

// Skeleton loader for consultation details
export function ConsultationDetailsSkeleton() {
    return (
        <div className="flex flex-col w-full h-full bg-white rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px] animate-pulse gap-4">
            <div className="h-8 w-2/3 bg-gray-200 rounded mb-2" />
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between mb-1 w-full">
                <div className="flex flex-col gap-2 w-full sm:w-auto">
                    <div className="h-8 w-1/2 bg-gray-200 rounded mb-1" />
                    <div className="flex gap-2">
                        <div className="h-4 w-20 bg-gray-200 rounded" />
                        <div className="h-4 w-12 bg-gray-200 rounded" />
                        <div className="h-4 w-10 bg-gray-200 rounded" />
                    </div>
                </div>
            </div>
            <div className="flex gap-2 mb-4">
                <div className="h-6 w-24 bg-gray-200 rounded" />
                <div className="h-6 w-16 bg-gray-200 rounded" />
            </div>
            <div className="flex flex-col w-full text-left pb-3 mb-6 gap-2">
                <div className="h-5 w-1/3 bg-gray-200 rounded mb-2" />
                <div className="grid grid-cols-[150px_1fr] gap-8">
                    <div className="flex flex-col gap-2">
                        <div className="h-4 w-16 bg-gray-200 rounded" />
                        <div className="h-4 w-20 bg-gray-200 rounded" />
                    </div>
                    <div className="flex flex-col gap-2">
                        <div className="h-4 w-20 bg-gray-200 rounded" />
                        <div className="h-4 w-24 bg-gray-200 rounded" />
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-3 w-full p-4 text-left rounded-[16px] border border-[#0404041A] pb-3 mb-6">
                <div className="h-6 w-1/3 bg-gray-200 rounded mb-2" />
                <div className="grid grid-cols-[min-content_1fr] text-sm gap-8">
                    <div className="flex flex-col gap-2">
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className="h-4 w-10 bg-gray-200 rounded" />
                        ))}
                    </div>
                    <div className="flex flex-col gap-2 font-medium">
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className="h-4 w-16 bg-gray-200 rounded" />
                        ))}
                    </div>
                </div>
            </div>
            <div className="w-full flex gap-4 bg-[#EBF0FB] p-4 rounded-[8px]">
                <div className="h-10 w-1/2 bg-gray-200 rounded" />
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-center w-full p-3 mt-4 gap-2">
                <div className="h-6 w-1/3 bg-gray-200 rounded" />
                <div className="h-10 w-24 bg-gray-200 rounded" />
            </div>
            <div className="mb-5 w-full flex flex-col gap-2">
                <div className="h-8 w-full bg-gray-200 rounded" />
                <div className="h-8 w-2/3 bg-gray-200 rounded" />
            </div>
        </div>
    )
}

// This component contains the actual consultation details content
export const ConsultationDetailsContent = ({ encounter }: { encounter: FormattedEncounter }) => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program")
    const { program } = routeApi.useParams()
    const { mutate: sendActionNeeded, isPending: sendActionpending } = useSendActionNeededMutation();

    // const handleAssignMedication = () => {
    //     console.log("Assign medication for encounter:");
    //     // Add your medication assignment logic here
    // };

    // const handleAssignAppointment = () => {
    //     console.log("Assign appointment for encounter:");
    //     // Add your appointment assignment logic here
    // };

    // Check for medication_payment tasks to determine resolved/action needed status
    const normalizedTasks = Array.isArray(encounter.recommendedTasks) ? encounter.recommendedTasks : [];
    const medicationPaymentTasks = normalizedTasks.filter(
        (task: any) => task?.type === "medication_payment"
    );

    // There may be multiple medication_payment tasks.
    const anyCompletedPayment = medicationPaymentTasks.some(
        (task: any) => task?.status === "completed"
    );
    const anyNotCompletedPayment = medicationPaymentTasks.some(
        (task: any) => task?.status !== "completed"
    );

    // Find the first completed task for erx check
    const completedPaymentTask = medicationPaymentTasks.find(
        (task: any) => task?.status === "completed"
    );

    // Only show status tags if the consultation has happened or is happening
    const hasConsultationOccurred = ["happening", "past", "completed", "attended"].includes(encounter.status);

    // showResolvedTag only if ALL are completed and is_erx_sent is true for the completed one.
    // showActionNeededTag if ANY are incomplete, OR if all are completed but is_erx_sent is NOT true for the completed one.
    const showResolvedTag = hasConsultationOccurred && completedPaymentTask?.is_erx_sent === true && !anyNotCompletedPayment;
    const showActionNeededTag = hasConsultationOccurred && (
        (anyNotCompletedPayment && anyCompletedPayment) || // some completed, some not
        (anyCompletedPayment && !anyNotCompletedPayment && completedPaymentTask?.is_erx_sent !== true) // all completed, but is_erx_sent is NOT true
    );
    const showInProgressTag =
        hasConsultationOccurred && !anyCompletedPayment && anyNotCompletedPayment;
    return (
        <>
            {program === "weight-loss" && (
                <div className="flex flex-col w-full h-full bg-[#FFFFFF] rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px]">
                    {/* Patient info section */}
                    <div className="flex items-center gap-2 mb-4">
                        {/* <span className="bg-[#4272DD1A] text-[#4272DD] text-xs font-medium py-[2px] px-[6px] rounded-[888px]  flex items-center gap-2 w-fit">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_7677_5977)">
                            <path d="M6.99935 13.3332C10.221 13.3332 12.8327 10.7215 12.8327 7.49984C12.8327 4.27818 10.221 1.6665 6.99935 1.6665C3.77769 1.6665 1.16602 4.27818 1.16602 7.49984C1.16602 10.7215 3.77769 13.3332 6.99935 13.3332Z" stroke="#4272DD" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_7677_5977">
                                <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                            </clipPath>
                        </defs>
                    </svg>
                    Action needed
                </span> */}

                        <div className="flex gap-2 items-center">
                            <ConsultationStatus
                                tag="Consultation"
                                program={program}
                            />
                            {showResolvedTag && (
                                <span className="text-xs font-medium py-[2px] px-[6px] rounded-full text-[#16A34A] bg-[#ECFDF3] border border-[#BAE6C3] w-fit flex items-center gap-1">
                                    <CircleCheck className="size-[14px] text-[#16A34A]" />
                                    Resolved
                                </span>
                            )}
                            {showActionNeededTag && (
                                <span className="text-xs font-medium py-[2px] px-[6px] rounded-full text-[#FFA726] bg-[#FFF5E6] border w-fit flex items-center gap-1">
                                    <Info className="size-[14px] text-[#FFA726]" />
                                    Action needed
                                </span>
                            )}
                            {showInProgressTag && (
                                <span className="text-xs font-medium py-[2px] px-[6px] rounded-full text-[#2563EB] bg-[#EFF6FF] border w-fit flex items-center gap-1">
                                    <Clock className="size-[14px] text-[#2563EB]" />
                                    In progress
                                </span>
                            )}
                        </div>

                    </div>
                    <ResolveToggle encounterId={encounter.encounterId} recommendedTasks={encounter.recommendedTasks} />
                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between mb-1 w-full">
                        <div className="flex flex-col gap-2 w-full sm:w-auto">
                            <div className="flex gap-2 items-center">
                                <h2 className="text-2xl sm:text-[32px] text-[#2D2F35] mb-1 font-medium max-w-full">
                                    {encounter?.title}
                                </h2>
                                {encounter.patient.medical_plan?.payment_status === "paid" && encounter.patient.glp1_guide_accepted && encounter.patient.identity_verified && encounter.patient.supplementary_health_assessment && Object.keys(encounter.patient.supplementary_health_assessment).length > 0 && (
                                    <div className="">
                                        <Image src="/icons/check.svg" alt="timeline" layout="constrained" className="w-4 h-4 sm:w-5 sm:h-5" width={96} height={96} />
                                    </div>

                                )}
                            </div>

                            <div className="flex flex-wrap items-center gap-y-1 gap-x-2">
                                {/* <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
                                    Weight Loss Program
                                </span> */}
                                {/* <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
                                    Urgent Care Program
                                </span> */}
                                {encounter.patient.age && (
                                    <>
                                        {/* <span className="hidden sm:inline mx-1" style={{ color: COLORS.TEXT_SECONDARY }}>
                                            •
                                        </span> */}
                                        <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
                                            {encounter?.patient.age} years
                                        </span>
                                    </>
                                )}
                                {encounter?.patient.gender && (
                                    <>
                                        <span className="hidden sm:inline mx-1" style={{ color: COLORS.TEXT_SECONDARY }}>
                                            •
                                        </span>
                                        <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
                                            {encounter?.patient.gender}
                                        </span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col w-full text-left pb-3 mb-6">
                        <h2 className="text-[#2D2F35] font-medium text-base mb-4">Request Information</h2>
                        <div className="grid grid-cols-[150px_1fr] gap-8">
                            <div className="flex flex-col gap-2">
                                <p className="text-[#464B55] text-sm">Program:</p>
                                <p className="text-[#464B55] text-sm">Request Date:</p>
                                <p className="text-[#1A202C] text-sm">Consultation:</p>
                            </div>
                            <div className="flex flex-col gap-2">
                                <p className="text-[#1A202C] text-sm">Weight Loss</p>
                                {/* <p className="text-[#1A202C] text-sm">Urgent Care</p> */}
                                <p className="text-[#1A202C] text-sm">{encounter?.createdAt}</p>
                                <p className="text-[#1A202C] text-sm">Express consultation</p>
                            </div>
                        </div>
                    </div>

                    <PatientDetailsConditional encounter={encounter} program={program} />

                    {/* <div className="w-full flex gap-4 bg-[#EBF0FB] p-4 rounded-[8px]">
                        <Link
                            className={cn(buttonVariants({ variant: "outline" }), "bg-transparent w-full text-[#4272DD] rounded-[8px] border-[#4272DD] border-2 py-3 px-4 hover:bg-[#4272DD] hover:text-white")}
                            to="/dashboard/$program/patients/patient/$id"
                            params={{
                                program: program,
                                id: encounter?.patient.id || ""
                            }}
                            search={{
                                name: encounter?.patient.name?.replace(/\s+/g, "") || "",
                                sessionId: encounter?.session?.session_id || ""
                            }}
                        >
                            View Patient Log
                        </Link>
                    </div> */}

                    {/* Notes Section */}
                    {encounter?.patient?.medical_plan?.payment_status === "paid" &&
                        encounter?.patient?.glp1_guide_accepted &&
                        encounter?.patient?.identity_verified &&
                        encounter?.patient?.supplementary_health_assessment &&
                        Object.keys(encounter.patient.supplementary_health_assessment).length > 0 && (
                            <div className="mt-4">
                                <NotesContainer
                                    encounterId={encounter.encounterId}
                                    patientId={encounter.patient.id}
                                />
                            </div>
                        )
                    }

                    {/* Recommended Tasks */}
                    {!(encounter?.patient?.medical_plan?.payment_status === "paid" &&
                        encounter?.patient?.glp1_guide_accepted &&
                        encounter?.patient?.identity_verified &&
                        encounter?.patient?.supplementary_health_assessment &&
                        Object.keys(encounter.patient.supplementary_health_assessment).length > 0) && (
                            <div className="flex items-center mt-4 bg-[#F0F5FF] rounded-lg px-4 py-2 justify-between w-full">
                                <p className="text-sm text-[#1A202C]">
                                    Patient must be verified
                                </p>
                                <Button
                                    className="button-primary !bg-[#4272DD] h-[44px] !text-white flex gap-2 items-center !shadow-none w-fit !border-none"
                                    onClick={async () => {
                                        try {
                                            await sendActionNeeded({ patient_id: encounter.patient.id });
                                            toast.success("Reminder sent to patient to complete verification.");
                                        } catch (error) {
                                            toast.error("Failed to send reminder.");
                                        }
                                    }}
                                    disabled={sendActionpending}
                                >
                                    {sendActionpending && (
                                        <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                        </svg>
                                    )}
                                    Send a Reminder
                                </Button>
                            </div>
                        )}
                    <RecommendedTask
                        encounterId={encounter.encounterId}
                        patientId={encounter.patient.id}
                        showAddButton={
                            encounter?.patient?.medical_plan?.payment_status === "paid" &&
                            encounter?.patient?.glp1_guide_accepted &&
                            encounter?.patient?.identity_verified &&
                            encounter?.patient?.supplementary_health_assessment &&
                            Object.keys(encounter.patient.supplementary_health_assessment).length > 0
                        }
                    />
                </div>
            )}
            {program === "urgent-care" && (
                <div className="flex flex-col w-full h-full bg-[#FFFFFF] rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px]">
                    {/* <div className="flex items-center gap-2 mb-4">
                        <span className="bg-[#7B238D26] text-[#B01F80] text-xs font-medium py-[2px] px-[6px] rounded-[888px]  w-fit flex items-center gap-1">
                            <Stethoscope size={12} />
                            Consultation
                        </span>
                        <span className="bg-[#FFF5E6] text-[#FF8C00] text-xs font-medium py-[2px] px-[6px] rounded-[888px]  w-fit flex items-center gap-1">
                            <Info size={12} />
                            Action needed
                        </span>
                    </div> */}
                    <div className="flex items-center justify-between gap-2 mb-4">
                        <ConsultationStatus
                            tag={
                                Array.isArray(encounter.recommendedTasks) &&
                                    encounter.recommendedTasks.some(
                                        (task) => task.type === "medication_payment" ||
                                            task.type === "no_action_needed"
                                    )
                                    ? "Resolved"
                                    : "Consultation"
                            }
                            program={program}
                        />
                        <ResolveToggle encounterId={encounter.encounterId} recommendedTasks={encounter.recommendedTasks} />
                    </div>


                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between mb-1 w-full">
                        <div className="flex flex-col gap-2 w-full sm:w-auto">
                            <h2 className="text-2xl sm:text-[32px] text-[#2D2F35] mb-1 font-medium max-w-full flex flex-row gap-2 sm:gap-3 sm:items-center items-start">
                                {encounter?.title}

                                {program === "urgent-care" ? (
                                    encounter.patient.urgent_care_onboarded && encounter.patient.identity_verified && (
                                        <div className="flex-shrink-0 mt-1 sm:mt-0">
                                            <Image src="/icons/check.svg"
                                                alt="timeline"
                                                className="w-4 h-4 sm:w-5 sm:h-5" layout="constrained" width={96} height={96} />
                                        </div>
                                    )
                                ) : (
                                    encounter.patient.medical_plan?.payment_status === "paid" &&
                                    encounter.patient.glp1_guide_accepted &&
                                    encounter.patient.identity_verified &&
                                    encounter.patient.supplementary_health_assessment &&
                                    Object.keys(encounter.patient.supplementary_health_assessment).length > 0 && (
                                        <div className="flex-shrink-0 mt-1 sm:mt-0">
                                            <Image src="/icons/check.svg"
                                                alt="timeline"
                                                className="w-4 h-4 sm:w-5 sm:h-5" layout="constrained" width={96} height={96} />
                                        </div>
                                    )
                                )}
                            </h2>

                            {/* <div className="flex flex-wrap items-center gap-y-1 gap-x-2 mb-1">
                                <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
                                    {encounter.patient.email}
                                </span>
                                {encounter?.patient.gender && (<><span className="hidden sm:inline mx-1" style={{ color: COLORS.TEXT_SECONDARY }}>•</span>
                                    <span className="text-sm" style={{ color: COLORS.TEXT_PRIMARY }}>
                                        {encounter?.patient.gender}
                                    </span></>)}
                            </div> */}
                        </div>
                    </div>

                    <div className="flex flex-col w-full text-left pb-3 mb-4 mt-4">
                        <div className="flex justify-between w-[80%]">
                            <div className="text-[#464B55] text-sm">
                                Submitted:
                                <p className="text-[#1A202C] text-sm">{encounter?.createdAt}</p>
                            </div>
                            <div className="text-[#464B55] text-sm">
                                Program:
                                <p className="text-[#1A202C] text-sm">Urgent Care</p>
                            </div>
                        </div>
                    </div>

                    <PatientDetailsConditional encounter={encounter} program={program} />

                    {/* {encounter.patient.urgent_care_onboarded && (
                            <NotesContainer
                                encounterId={encounter.encounterId}
                                patientId={encounter.patient.id}
                                notes={encounter.notes}
                                icd={encounter.session?.icd10_code}
                            />
                        )
                    } */}

                    {/* <div className="mt-3">
                        <UrgentCareTaskButtons
                            onAssignMedication={handleAssignMedication}
                            onAssignAppointment={handleAssignAppointment}
                        // selectedSession={selectedSession}
                        />
                    </div> */}

                    {/* Recommended Tasks */}
                </div>
            )}
        </>
    )
}
